import React from 'react';
import { ToastIntent } from '@fluentui/react-components';
import { authenticateTo360 } from '../services/api/authService';
import { getEnvironment360URL } from '../services/configs/appConfig';

interface OutlookTestActionsOptions {
    setShowSpinner: React.Dispatch<React.SetStateAction<boolean>>;
    showToast: (message: string, toastType: ToastIntent) => void;
}

export const useOutlookTestActions = ({ setShowSpinner, showToast }: OutlookTestActionsOptions) => {
    const testPing = async () => {
        const p360Url = getEnvironment360URL();
        if (!p360Url) return showToast('360 URL not configured', 'error');
        setShowSpinner(true);
        try {
            const response = await fetch(`${p360Url}/Biz/v2/api/call/SI.Biz.Core.OfficeAddin/SI.Biz.Core.OfficeAddin/OutlookService/Ping`, {
                method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({})
            });
            if (!response.ok) throw new Error(`Ping failed: ${response.status}`);
            const result = await response.json() as { Status?: string };
            showToast(`Ping successful! Status: ${result.Status || 'ok'}`, 'success');
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : String(error);
            showToast(`Ping failed: ${errorMessage}`, 'error');
        } finally {
            setShowSpinner(false);
        }
    };

    const testAuthenticate = async () => {
        const p360Url = getEnvironment360URL();
        if (!p360Url) return showToast('360 URL not configured', 'error');
        setShowSpinner(true);
        try {
            await authenticateTo360(p360Url, true);
            showToast('Auth success', 'success');
        } catch (error) {
            showToast(`Auth failed: ${String(error)}`, 'error');
        } finally {
            setShowSpinner(false);
        }
    };

    return { testAuthenticate, testPing };
};